<template>

    <div class="rf">  <!--交付表-->
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="100px" size="mini">
            <div class="formDiv">
                <div class="item">
                    <el-form-item class="form-title" prop="wtname" :label="$t('promanagement_processing_unit')">
                        <el-input v-model="formData.wtname" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="gsname" :label="$t('form_entrust_company')">
                        <el-input v-model="formData.gsname" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="bmname" :label="$t('promanagement_processing_department')">
                        <el-input v-model="formData.bmname" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title num" prop="num" label="No:">
                        <span v-model="formData.num" style="color:#b3d268;font-size: 16px;font-style: italic;width: 150px;">{{formData.num}}</span>
                    </el-form-item>
                </div>
                <div class="item">
                    <el-form-item class="form-title" prop="ckname" :label="$t('form_warehouse')">
                        <el-input v-model="formData.ckname" disabled>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="form-title" prop="vc_pno" :label="$t('promanagement_production_task_number')">
                        <el-input v-model="formData.vc_pno" disabled>
                        </el-input>
                    </el-form-item>
                </div>
            </div>
            <div style="margin-bottom: 20px">
                <template>
                    <el-row>{{$t('promanagement_output_delivery_details')}}</el-row>
                    <el-table
                            border
                            size="mini"
                            ref="multipleTable"
                            :data="jftableData"
                            height="220"
                            v-loading="loading"
                            :element-loading-text="$t('tips_submitting')"
                            :row-class-name="tableRowClassName"
                            tooltip-effect="dark"
                            style="width: 100%;">
                        <el-table-column
                                :label="$t('form_serial_number')"
                                align="left"
                                type="index"
                                width="55">
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="vc_hqgsname"
                                :label="$t('form_goods_rights_company')"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="vc_pzname"
                                :label="$t('form_product_name')"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="vc_no"
                                :label="$t('form_batch_number')"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="vc_unit"
                                :label="$t('form_metering')"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="kysl"
                                :label="$t('form_available_quantity')"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                align="left"
                                prop="f_num"
                                :label="$t('form_delivery_quantity')">
                            <template slot-scope="scope">
                                <el-input-number :disabled="edit==false?false:true" :controls="false" :precision="$setPrecision.quantityPrecision"
                                                 class="" size="mini" v-model="scope.row.f_num" :min="0"
                                                 @change="xhChange(scope.row,scope.$index)"></el-input-number>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="50" v-if="i_id==0">
                            <template slot="header" slot-scope="scope">
                                <el-popover
                                        class="pop"
                                        placement="bottom-end"
                                        width="1000"
                                        trigger="manual"
                                        v-model="visible">
                                    <template>
                                        <render-details v-if="visible==true" :renderDetails="renderDetails"
                                                        @closePop="closePop" @transValue="transValue"></render-details>
                                    </template>
                                    <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn"><i
                                            class="el-icon-plus"></i></el-button>
                                </el-popover>
                            </template>
                            <template slot-scope="scope">
                                <div class="iconminus">
                                    <span class="minus" @click="deleteRow(scope.row,scope.$index)"><i
                                            class="el-icon-minus"></i></span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <!--
                                <template>
                                    <el-row>总消耗明细</el-row>
                                    <el-table
                                            border
                                            size="mini"
                                            ref="multipleTable"
                                            :data="xhtableData"
                                            height="296"
                                            :row-class-name="tableRowClassName"
                                            tooltip-effect="dark"
                                            style="width: 100%;">
                                        <el-table-column
                                                label="序号"
                                                align="left"
                                                type="index"
                                                width="55">
                                        </el-table-column>
                                        <el-table-column
                                                align="left"
                                                prop="vc_hqgsname"
                                                label="货权公司"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                align="left"
                                                prop="vc_pzname"
                                                label="品名"
                                                width=""
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                align="left"
                                                prop="vc_no"
                                                label="批次号"
                    width="200"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                align="left"
                                                prop="vc_unit"
                                                :label="$t('form_metering')"
                                                width="80"
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                align="left"
                                                prop="f_cbprice"
                                                label="单价"
                                                width=""
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                align="left"
                                                prop="f_per_xh"
                                                label="实际消耗量"
                                                width=""
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                align="left"
                                                prop="f_require"
                                                label="需求量"
                                                width=""
                                                show-overflow-tooltip>
                                        </el-table-column>
                                        <el-table-column
                                                align="left"
                                                prop="f_cb"
                                                label="成本"
                                                width=""
                                                show-overflow-tooltip>
                                        </el-table-column>
                                    </el-table>
                                </template>
                -->
            </div>
            <div class="flex mrl20 mrb20 img-box">
                <ul v-if="imgList.length>0" class="uploadPhon flex list" id="formul">
                    <li class="li-img item" v-for="(oneimg,index) in imgList" :key="index">
                        <a
                        :download="oneimg.vc_name"
                        mce_href="#"
                        :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+oneimg.filenewname+',deliver\'}','utf-8')">
<!--:herf="file"-->     {{oneimg.vc_name}}
                        </a>
                        <i class="el-icon-delete" @click="removeli(oneimg,index)" v-if="commit==false"></i>
                    </li>
                </ul>
                <div class="upload-box" v-model="formData.imgList">
                    <input type="file" name="files" id="uploadfile1"
                           class="upload-input uploadfile1" @change="upload" style="margin-right: 10px"
                           :disabled="commit">
                    <el-button size="small" type="primary" :class="baseerp+'btn'" :disabled="commit"> 上传附件</el-button>
                </div>
            </div>
            <!--
                            <el-upload
                                    class="upload-demo flex"
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    :on-preview="handlePreview"
                                    :on-remove="handleRemove"
                                    :before-remove="beforeRemove"
                                    multiple
                                    :limit="3"
                                    :on-exceed="handleExceed"
                                    :file-list="fileList">
                                <el-button size="small" type="primary" :class="baseerp+'btn'" class="mrl20 mrb20">上传附件</el-button>
                            </el-upload>
            -->
            <el-form-item class="form-title" prop="vc_note" :label="$t('form_notes')">
                <el-input v-model="formData.vc_note" :disabled="votevote">
                </el-input>
            </el-form-item>
            <div class="formDiv flex">
                <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_creator')">
                    <el-input v-model="formData.vc_lruname" disabled>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="date" :label="$t('form_date')">
                    <el-input v-model="formData.date" disabled>
                    </el-input>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <el-button type="primary" v-if="edit==false" :class="baseerp+'btn'" @click="saveData" :disabled="disabled" size="small">
                保存
            </el-button>
            <el-button type="primary" :class="baseerp+'btn'" @click="submitDta" :disabled="commit" size="small">{{$t('button_submit')}}</el-button>
            <el-button type="danger" v-if="edit==true" @click="toVoid"  size="small" :disabled="getvoid">
<!--                :disabled="this.editForm.i_state==0?false:true"-->{{$t('button_nullify')}}
            </el-button>
            <!--
                        <el-button type="primary" @click="saveForm" v-if="i_state==0" :class="baseerp+'btn'">保存并提交</el-button>
                        <el-button type="success" @click="renderForm" v-if="i_state==1" >交付</el-button>
            -->
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";
    import RenderDetails from "./RenderDetails";

    export default {
        name: "RenderForm",
        components: {RenderDetails},
        props: {
            render: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                getvoid:false,
                commit: false,
                picId: [],
                didNum: 1,
                abdand: false,
                votevote: true,
                commitId: '',
                saveId: 0,
                disabled: false,
                tableId: 0,
                fileList: [],
                isbtn: false,
                visible: false,
                renderDetails: {},
                edit: false,
                jgcost: "",
                bzcost: "",
                formData: {
                    // gsname:"",
                    // bmname:"",
                    // jgcost:"",
                    // wtname:"",
                    // pcnum:"",
                    // jfnum:"",
                    // vc_pno:"",
                    // ccpro:"",
                    // ckname:"",
                    // num:"000000",
                    // vc_note:"",
                    // vc_lruname: sessionStorage.getItem("lruname"),
                    // date:"",
                    // jftableData:[],
                    // xhtableData:[],
                    // imgList:[],
                    // bzcost:"",
                },
                formRules: {
                    jgcost: [{required: true, message:this.$t('promanagement_please_enter_the_processing_fee') , trigger: "blur"}],
                },
                imgList: [],
                imgLength: 0,
                jftableData: [],
                xhtableData: [],
                baseerp: "",
                file_url: '',
                baseApp:"",
                baseVersion:"",
                i_id: 0,
                f_outnum: 0,
                i_outid: 0,
                form: {},
                formList: [],
                vc_plat: "",
                i_state: "",
                jfsum: 0,
                ids: [],
                fileName: "",
                mid: 0,
                newCommit: [],
                newarr: [],
                deleteLi: "",
                deleteLidex: "",
                filenewname: '',
                deliverit: "deliver",
                file:"",
                loading:false,
                token:"",
                i_uid:"",
            }
        },

        watch: {
            render: {
                handler() {
                    if (this.render) {
                        //this.pageSize=this.page_size;
                        this.i_id = this.render.i_id;
                        this.mid = this.render.i_mid;
                        if (this.render.i_id == 0) {
                            this.getDateYYYYMMddHHMMSS();
                            this.title = this.render.title;
                            this.form = this.render.taskDa;
                            //this.formList=this.render.taskDa;
                            // console.log(this.render,this.title,this.form,"i_id",this.render.i_id)
                            this.renderDetails = this.render.taskDa;
                            this.renderDetails.i_mid = this.mid;
                            this.renderDetails.selected=[];
                            this.edit = false;
                            this.chakan = false;
                            this.votevote = false;
                            this.commit = true;
                            this.formData = {
                                wtname: this.form.vc_outgsname,
                                gsname: this.form.vc_gsname,
                                bmname: this.form.vc_cjname,
                                num: "000000",
                                ckname: this.form.vc_ckname,
                                vc_pno: this.form.vc_pno,
                                vc_note: "",
                                vc_lruname: sessionStorage.getItem("lruname"),
                                date: this.date,
                                jftableData: [],
                                //xhtableData:[],
                                //sqname:sessionStorage.getItem("lruname"),
                            };
                        } else {
                            /*if (this.feeding.title=="预览"){
                                this.chakan=true;
                            }else {
                                this.chakan=false;
                            }*/
                            //编辑
                            this.votevote = true;
                            this.edit = true;
                            this.isbtn = true;
                            this.editForm = this.render.value;
                            this.getvoid=this.editForm.i_state==0?false:true;
                            this.form = this.render.taskDa;
                            this.title = this.render.title;
                            this.commit = this.editForm.i_state != 0 ? true : false;
                            // console.log(this.render,this.title,this.form,this.editForm,"i_id",this.render.i_id)
                            this.formData = {
                                wtname: this.form.vc_outgsname,
                                gsname: this.form.vc_gsname,
                                bmname: this.form.vc_cjname,
                                num: "000000",
                                ckname: this.form.vc_ckname,
                                vc_pno: this.form.vc_pno,
                                vc_note: this.editForm.vc_note,
                                vc_lruname: sessionStorage.getItem("lruname"),
                                date: this.editForm.dt_createtime,
                                jftableData: [],
                                // xhtableData:[],
                                // sqname:sessionStorage.getItem("lruname"),
                            };
                            //调点击编辑查看交付单时调用的接口
                            this.getOutputDetails();
                        }
                    }
                },
                immediate: true,
                deep: true
            }
        },

        mounted() {
            this.baseerp = baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
           // console.log(this.formData.imgList,"this.formddddddd")
            this.file_url = file_url;
            this.file=this.file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');
            //this.file = this.file_url + 'param=' + '{app:"' + "jxcweb" + '",i_uid:' + sessionStorage.getItem("userid") + ',token:"' + sessionStorage.getItem("token") + '",version:"' + "1.0" + '",fid:"' + this.filenewname + ",deliver" + '"}';
            // this.title=this.render.title;
            // this.formList=this.render.value;
            // console.log(this.formList,"拿到外表数据");
            // if (this.title=="批量提交单"){
            //     this.plassignment();
            //     this.edit=false;
            //     this.disabled=false;
            // }else{
            //     this.assignment();
            // }
        },

        methods: {

            //下载
            /*downLoad(oneimg) {
                this.filenewname = oneimg.filenewname;
                console.log(oneimg, this.filenewname, "oneimg")
                //var file = this.file_url + '?param=' + encodeURI('{app:"' + config.userAgent + '",i_uid:' + config.userId + ',token:"' + config.oaToken + '",version:"' + config.app_version + '",fid:"' + fileName + ",deliver" + '"}');
            },*/

            //删除li
            removeli(oneimg, index) {
                //console.log(oneimg, index, "oneimg")
                this.deleteLi = oneimg.fileid;
                this.deleteLidex = index;
                this.deletefile();
                //拿到oneimg里面的fileid
                //调接口
                /* if (this.imgList.length==0){
                     console.log(oneimg,index,"oneimg")
                     this.deleteLi=oneimg.fileid;
                     this.deleteLidex=index;
                     this.deletefile();
                     //拿到oneimg里面的fileid
                     //调接口
                 }else{
                     console.log(oneimg,index,"oneimg")
                     this.deleteLi=oneimg.i_id;
                     this.deleteLidex=index;
                     this.deletefile();
                     //拿到oneimg里面的fileid
                     //调接口
                 }*/
            },

            //li删除接口
            async deletefile() {
                let param = {
                    i_id: this.deleteLi,
                };
                let res = await API.deleteFileInfo(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.imgList.splice(this.deleteLidex, 1);
                    //console.log(this.imgList, "newlist");
                    this.newarr = this.imgList;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //点击作废
            toVoid() {
                this.voidOutput();
            },

            //点击提交
            submitDta() {
                this.loading=true;
                this.flowSub();

            },

            //点击保存时
            saveData() {

                // console.log(this.jfsum, "jfsum");
                if (this.jfsum == 0) {
                    this.$message.error(this.$t('promanagement_the_delivery_quantity_cannot_be_0'));
                } else if (this.title == "新增") {
                    this.loading=true;
                    this.saveId = 0;
                    this.saveOutput();
                    //console.log(this.saveId, "新增")
                } else {
                    this.loading=true;
                    this.saveId = this.editForm.i_id;
                    this.saveOutput();
                    //console.log(this.saveId, "编辑")
                }
            },

            deleteRow(value, index) {
                this.index = index;
                this.jftableData.splice(this.index, 1);
                // console.log(value,"-----")
            },

            //把子子表数据传给子表产品列表
            transValue(value) {
                /*let arr=[];
                if ( this.formData.tableData.length>0){

                }else {
                     arr=[...value];
                }*/
                let arr = [...this.jftableData, ...value];
                // console.log(value, "------------");
                //console.log(arr,"arrrrrrrrrrrrr")
                /*const vc_pzid='vc_pzid';
                const vc_no='vc_no';
                const i_scid='i_scid';
                //console.log(item,"--item--",next)
                const newArr = arr.reduce((all,next)=>all.some((item)=>item[vc_pzid]==next[vc_pzid])?all:[...all,next],[]);
                const newArr2 = newArr.reduce((all,next)=>all.some((item)=>item[vc_no]==next[vc_no])?all:[...all,next],[]);
                const newArr3 = newArr2.reduce((all,next)=>all.some((item)=>item[i_scid]==next[i_scid])?all:[...all,next],[]);

*/
                let hash = {};
                arr = arr.reduce(function(item, next) {
                    hash[next.vc_unique] ? '' : hash[next.vc_unique] = true && item.push(next);
                    return item
                }, []);
                this.formData.jftableData = arr;
                this.jftableData = arr;
                this.renderDetails.selected=this.jftableData;
                // console.log(this.jftableData, "拿到子子数据传子")
                this.ids = this.jftableData.reduce((pre, cur) => [...pre, cur.i_scid], []);
                this.jfsum = this.jftableData.reduce((pre, cur) => this.$math.add(pre, cur.f_num), 0);
                if (value.length == 0) {
                    this.$message.error(this.$t('promanagement_please_select_a_batch_order'));
                } else {
                    //this.getConsumeList();
                }
            },

            //input输入
            xhChange(val, index) {
                //console.log(val, index, "xh");
                if (this.jftableData[index].kysl < val.f_num) {
                    this.$message.error(this.$t('promanagement_the_delivery_quantity_shall_not_exceed_the_available_quantity'));
                    this.jftableData[index].f_num = this.jftableData[index].kysl;
                }
                this.ids = this.jftableData.reduce((pre, cur) => [...pre, cur.i_scid], []);
                this.jfsum = this.jftableData.reduce((pre, cur) => this.$math.add(pre, cur.f_num), 0);
                //this.getConsumeList();
                //this.tableData[index].f_syzx=this.$math.subtract(this.tableData[index].f_zx,this.tableData[index].f_innum);
                //this.tableId=Math.random();

            },

            //点击编辑查看交付单时调用的接口
            async getOutputDetails() {
                let param = {
                    i_mid: this.mid,
                    i_id: this.editForm.i_pid,
                }
                let res = await API.getOutputDetails(param);
                if (res.code == 1) {
                    this.formData = {
                        wtname: this.form.vc_outgsname,
                        gsname: this.form.vc_gsname,
                        ckname: this.form.vc_ckname,
                        bmname: this.form.vc_cjname,
                        vc_pno: this.form.vc_pno,
                        vc_note: res.data.vc_note,
                        num: res.data.vc_scno,
                        date: res.data.dt_createtime,
                        vc_lruname: sessionStorage.getItem("lruname"),
                        jftableData: res.data.details,
                        imgList: res.data.files,
                        //xhtableData:res.data.prouseXh,
                    };
                    this.imgList = res.data.files;
                    this.jftableData = res.data.details;
                    //this.xhtableData=res.data.prouseXh;
                    this.commitId = res.data.i_id;
                    //console.log(this.commitId, this.formData,this.formData.imgList, "给作废和审批")
                    //this.saveId=res.data.i_id;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            popShow() {
                this.visible = true;
                //console.log(this.visible)
                if (this.visible == true) {
                    this.isbtn = true
                }
            },

            closePop() {
                this.visible = false;
                this.isbtn = false;
            },

            //批量
            // plassignment() {
            //     /*this.formList = [
            //         {details: [{jfnum: 1.1, name: "j"}, {jfnum: 1, name: "j"}], name: {qname: "a"}},
            //         /!*{details: [{jfnum: 3.03, name: "j"}, {jfnum: 1, name: "j"}], name: {qname: "d"}},
            //         {details: [{jfnum: 3.253, name: "j"}, {jfnum: 1, name: "j"}], name: {qname: "l"}},
            //         {details: [{jfnum: 9.589, name: "j"}, {jfnum: 1, name: "t"}], name: {qname: "v"}},*!/
            //     ]*/
            //     /*if (this.formList.length == 1) {
            //         this.jftableData = this.formList[0].details;
            //     } else {
            //         let arr = this.formList.reduce((pre, cur) =>
            //             Array.isArray(pre) ? [...pre, ...cur.details] : [...pre.details, ...cur.details]
            //         );
            //         this.jftableData = arr;
            //     }*/
            //     this.jftableData=[...this.jftableData,...this.formList];
            //     this.ids=this.formList.reduce((pre,cur)=>[...pre,cur.i_id],[]);
            //     this.vc_plat=this.formList[0].vc_plat;
            //     this.jfsum=this.formList.reduce((pre,cur)=>this.$math.add(pre, cur.f_outnum), 0);
            //     // console.log("this.ids")
            //     this.formData = {
            //         gsname: this.formList[0].vc_outgsname,
            //         bmname: this.formList[0].vc_gname,
            //         jgcost: this.$math.multiply(this.jfsum,this.formList[0].f_jgmoney),
            //         wtname: this.formList[0].vc_ingsname,
            //         pcnum: this.formList[0].vc_no,
            //         ccpro: this.formList[0].vc_pzname,
            //         ckname: this.formList[0].vc_ckname,
            //         num: this.formList[0].i_outid,
            //         vc_note: this.formList[0].vc_jfnote,
            //         vc_lruname: sessionStorage.getItem("lruname"),
            //         date: this.formList[0].dt_lrcreatetime,
            //     };
            //
            //     this.getConsumeList();
            //     // this.getProduceOdd();
            //     // console.log(this.jfsum,"======jfsum")
            // },
            //赋值
            // assignment() {
            //     this.jftableData=[...this.jftableData,this.formList];
            //     this.vc_plat = this.formList.vc_plat;
            //     this.i_state = this.formList.i_state;
            //     this.i_outid = this.formList.i_outid;
            //     this.i_id = this.formList.i_id;
            //     this.ids=[...this.ids,this.i_id];
            //     this.jfsum = this.formList.f_outnum;
            //     this.formData = {
            //         gsname: this.formList.vc_outgsname,
            //         bmname: this.formList.vc_gname,
            //         jgcost: this.$math.multiply(this.jfsum,this.formList.f_jgmoney),
            //         wtname: this.formList.vc_ingsname,
            //         pcnum: this.formList.vc_no,
            //         jfnum: this.formList.f_outnum,
            //         ccpro: this.formList.vc_pzname,
            //         ckname: this.formList.vc_ckname,
            //         num: this.formList.i_outid,
            //         vc_note: this.formList.vc_jfnote,
            //         vc_lruname: sessionStorage.getItem("lruname"),
            //         date: this.formList.dt_lrcreatetime,
            //     };
            //     // if (this.title == "查看交付单" || this.title == "产品查看") {
            //     //     this.getProduceOdd();
            //     //     this.edit = true;
            //     //     this.disabled = true;
            //     // } else if (this.title == "提交交付单") {
            //     //     this.getProduceOdd();
            //     //     //this.getConsumeList();
            //     //     this.edit = false;
            //     //     this.disabled = true;
            //     // } else if (this.title == "产品提交") {
            //     //     this.getConsumeList();
            //     //     this.edit = false;
            //     //     this.disabled = false;
            //     // }
            //     //
            //     // if (this.title == "产品产出" && this.i_state == -1) {
            //     //     this.i_outid = '0'
            //     // }
            // },


            //获取消耗列表
            // async getConsumeList() {
            //     let param = {
            //         ids: this.ids,
            //         i_mid: this.mid,
            //         jfsum: this.jfsum,
            //     };
            //     let res = await API.getConsumeList(param);
            //     if (res.code == 1) {
            //         this.xhtableData = res.data;
            //         this.formData.xhtableData = res.data;
            //         this.formData.bzcost = res.bzfy;
            //         //this.$message.success(res.message);
            //     } else if (res.code == -2) {
            //         this.$router.push('/login');
            //         this.$message.error(res.message);
            //     } else {
            //         this.$message.error(res.message);
            //     }
            //
            // },

            //保存产出交付
            async saveOutput() {
                this.disabled=true;

                // console.log(this.form, "左侧数据")
                let param = {
                    i_mid: this.mid,
                    i_id: this.saveId,
                    i_outgsid: this.form.i_gsid_out,
                    i_ingsid: this.form.i_gsid,
                    i_gid: this.form.i_cjid,
                    i_ckid: this.form.i_ckid,
                    i_rwid: this.form.i_id,
                    i_pzid: this.form.i_pzid,
                    f_jgmoney: this.form.jgcost,
                    vc_note: this.formData.vc_note,
                    vc_scno: this.form.vc_pno,
                    details: this.jftableData,
                    //prouseXh: this.formData.xhtableData,
                };
                let res = await API.saveOutput(param);
                if (res.code == 1) {
                    this.commit = false;
                    this.loading=false;
                    let value = {
                        wtgsid: this.form.i_id,
                        pageSize: this.render.page_size,
                    };
                    this.commitId = res.i_id;
                    this.$emit('getOutputList', value);
                    //this.$emit('close');
                    this.$message.success(res.message);
                    this.disabled = true;
                    // console.log(this.commitId, "给作废和审批");
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //提交审批接口
            async flowSub() {
                // console.log(this.imgList, this.newarr, "imgList")
                this.newarr = this.imgList.map((item, index, arr) => {
                    return item.fileid;
                }).toString();
                // console.log(this.newarr, "newarrr")


                /*if (this.imgList.length == 0) {
                    this.loading=false;
                    this.$message.error("请上传附件后再提交");
                } else {*/
                    // console.log("提交成功")
                    let param = {
                        appid: this.commitId,
                        fileid: this.newarr,
                        flowid: 29,
                        i_mid: this.mid,
                    }
                    this.commit = true;
                    let res = await API.flowSub(param);
                    if (res.code == 1) {
                        //console.log(res.data,fileid,"提交审批")
                        this.loading=false;
                        let value = {
                            wtgsid: this.commitId,
                            pageSize: this.render.page_size,
                        };
                        this.$emit('getOutputList', value);
                        this.$emit('close');
                        this.commit = true;
                        this.$message.success(res.message);
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                /*}*/
            },


            //作废接口
            async voidOutput() {
                this.getvoid=true;

                let param = {
                    i_mid: this.mid,
                    i_id: this.commitId,
                };
                let res = await API.voidOutput(param);
                if (res.code == 1) {
                    let value = {
                        wtgsid: this.editForm.i_id,
                        pageSize: this.render.page_size,
                        row: this.editForm
                    };
                    this.$message.success(res.message);
                    this.$emit('getOutputList', value);
                    this.$emit('close');
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },


            tableRowClassName({row, rowIndex}) {
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },

            cancel() {
                //console.log(this.pageSize,"------")
                this.$emit('close');
                //this.$emit('getEntrustCompanyHaveList')
            },

            //获取当天日期
            getDateYYYYMMddHHMMSS() {
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.date = `${date.getFullYear()}-${month}-${strDate}`;
                //console.log(this.formData.date)
            },

            //上传附件
            async upload(value) {
                //console.log(this.commitId, "thie.commitId")
                if (this.commitId.length == 0) {
                    this.$message.error(this.$t('promanagement_please_upload_the_attachment_after_saving'));
                } else {
                    //console.log(value, "vaaaaaaaaaaaaaaa")
                    let that = this;
                    let i = 0;
                    let $files = value.target.files[0];
                    let fileName = $files.name;
                    let type = $files.type;
                    var list = {
                        "image/jpeg": true,
                        "image/png": true,
                        "image/jpg": true,
                        "image/bmp": true,
                        "application/pdf": true
                    };
                    let result = list[type];
                    // if(($files && result==false) || ($files &&result==undefined)){
                    //     that.$message.error('请上传格式正确的文件');
                    //     return;
                    // };
                    if ($files) {
                        that.fileName = $files.name;
                        that.fileType = $files.type;
                        that.fileUrl = window.URL.createObjectURL(value.target.files[0]);
                    } else {
                        that.fileName = "";
                        that.fileType = "";
                        that.fileUrl = "";
                    }
                    if (that.fileName) {
                        var fileId = 'uploadfile' + that.idNum;
                        var param = {
                            "file": fileId,
                            "fileName": that.fileName,
                            "IDtype": "",
                            "type": 1,
                            "style": "deliver",
                            "files": $files,
                            //"token":sessionStorage.getItem("token"),
                            "app": "dsmanage",
                            "vc_app": "deliver",
                            "i_appid": this.commitId,
                            "version": "1.0",
                            "i_uid": sessionStorage.getItem("userid"),
                            "vc_lruname": this.form.vc_lruname,
                            "i_lruid": this.form.i_lruid,
                            "i_mid": this.mid
                        };
                        /*let abc = {
                            i_mid: this.mid,
                            style:"deliver",
                            vc_app:"deliver",
                            i_appid:this.commitId,
                            vc_lruname:this.form.vc_lruname,
                            i_lruid:this.form.i_lruid,
                        };*/
                        let FD = new FormData();
                        for (let key in param) {
                            FD.append(key, param[key])
                        }
                        // let res = await  fetch(upload,{
                        //     method:"post",
                        //     body:FD
                        // }).then(res=>res.text());
                        let res = await API.upload(param);
                        if (res.code == 1) {
                            //res =JSON.parse(res);
                            let data = res.data[0];
                            var imgPath = {};
                            imgPath.fileid = data.i_id;
                            imgPath.vc_name = data.filename;
                            imgPath.base64 = data.base64String;
                            imgPath.filePath = data.i_id;
                            imgPath.fileSort = that.didNum;
                            imgPath.fileType = 1;
                            imgPath.filenewname = data.filenewname;
                            that.imgList.push(imgPath);
                            that.didNum++;
                            that.idNum = that.didNum;
                            that.imgLength = that.imgList.length - 1;
                            that.formData.imgList = that.imgList;
                            //console.log(data, that.imgList, that.formData.imgList, "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx")
                            //this.removeli();
                            //console.log(that.imgList, "newlist")
                        } else if (res.code == -2) {
                            this.$router.push('/login');
                            this.$message.error(res.message);
                        } else {
                            that.$message.error(res.message);
                        }
                    }
                }

            },

            //保存图片
            // async upload() {
            //     let param = {
            //         i_mid: this.mid,
            //         style:"",
            //         vc_app:"",
            //         i_appid:"",
            //         i_recordid:this.commitId,
            //         vc_lruname:this.form.vc_lruname,
            //         i_lruid:this.form.i_lruid,
            //     };
            //         let res = await API.upload(param);
            //         if (res.code == 1) {
            //             this.$message({
            //                 type: 'success',
            //                 message: '保存成功'
            //             });
            //             // this.getList();
            //             // this.dialogFormVisibleeditPic=false;
            //         } else if (res.code == -2) {
            //             this.$router.push('/login');
            //             this.$message.error(res.message);
            //         }else{
            //             this.$message.error("保存失败");
            //             // this.dialogFormVisibleeditPic=false;
            //         }
            //
            // },

        },
    }
</script>

<style lang="scss" scoped>

    body {
        margin: 0;
    }

    .img-box {
        /*border: 1px solid red;*/
        margin: 10px;

        .uploadPhone {
            width: 70px;
            height: 80px;
            position: relative;
            width: 100%;
            /*border: 1px solid cornflowerblue;*/
        }

        .uploadPhone img {
            width: 70px;
            height: 80px;
        }

        .upload-box {
            /*background: red;*/
            width: 30%;
            height: 30%;
        }

        .upload-input {
            position: absolute;
            opacity: 0;
            width: 70px;
            height: 80px;
        }
    }

    .flex {
        display: flex;
    }

    .item {
        width: 100%;
    }

    .mrl20 {
        margin-left: 60px;
    }

    .mrb20 {
        margin-bottom: 10px;
    }


    .upload-input {
        position: absolute;
        opacity: 0;
        width: 70px;
        height: 80px;
    }

    /deep/ {
        .num {
            margin-bottom: 12px;
        }

        .num .el-form-item__label{
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }
        .danger-row {
            color: #999;
        }
    }
</style>